export default __webpack_public_path__ + "static/illustration-content.url-51a300217ef90b7a6f531728301360d3.svg";